const INIT_STATE = {
    isOpen: false,
    eventFeedback: '',
    isShowingMessage: '',
    mediumResizeWidth: 2,
    isMenu: false,
    isMenuData: null,
};

export default function Config(state = INIT_STATE, action) {
    switch (action.type) {
        case "IS_OPEN":
            return {
                ...state,
                isOpen: !state.isOpen
            };
        case "EVENT_FEEDBACK":
            return {
                ...state,
                eventFeedback: action.payload
            };
        case "ADD_MARK":
            return {
                ...state,
                isShowingMessage: action.payload
            };
        case "CHANGE_RESIZE_CAROUSEL":
            return {
                ...state,
                mediumResizeWidth: action.payload
            };
        case "MENU_RECEIVER":
            return {
                ...state,
                isMenu: true,
                isMenuData: action.payload
            };
        case "MENU_SENDER":
            return {
                ...state,
                isMenu: false,
                isMenuData: null,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/config.js